import KitImg from '@/assets/img/tmp/involve/party_kit_img@2x.jpg';
import Image from '@/components/Image';
import React, { FC } from 'react';
import styled from 'styled-components';

const StepContainer = styled.div`
  padding-top: 32px;
  padding-bottom: 100px;

  .cnt-list {
    max-width: 500px;
    margin: 0 auto;
    margin-top: 24px;
    & > li {
      padding-left: 23px;
      width: 50%;
      margin-bottom: 8px;
      position: relative;
      line-height: 2;

      &:before {
        display: block;
        width: 16px;
        line-height: 16px;
        border-radius: 100%;
        background: #1cabe2;
        color: #fff;
        text-align: center;
        font-size: 10px;
        font-weight: 700;
        position: absolute;
        left: 0;
        top: 9px;
      }

      &:nth-child(1) {
        &::before {
          content: '1';
        }
      }
      &:nth-child(2) {
        order: 3;
        &::before {
          content: '2';
        }
      }
      &:nth-child(3) {
        order: 5;
        &::before {
          content: '3';
        }
      }
      &:nth-child(4) {
        order: 7;
        &::before {
          content: '4';
        }
      }
      &:nth-child(5) {
        order: 9;
        &::before {
          content: '5';
        }
      }
      &:nth-child(6) {
        order: 2;
        &::before {
          content: '6';
        }
      }
      &:nth-child(7) {
        order: 4;
        &::before {
          content: '7';
        }
      }
      &:nth-child(8) {
        order: 6;
        &::before {
          content: '8';
        }
      }
      &:nth-child(9) {
        order: 8;
        &::before {
          content: '9';
        }
      }
      &:nth-child(10) {
        order: 10;
        &::before {
          content: '10';
        }
      }
    }
  }
`;

const PartyKit: FC = () => (
  <StepContainer>
    <figure>
      <Image pcSrc={KitImg} mobileSrc={KitImg} />
    </figure>
    <ul className="cnt-list flex">
      <li>Party for UNICEF</li>
      <li>파티 허가증</li>
      <li>포스터 4종</li>
      <li>현수막</li>
      <li>가랜드 DIY</li>
      <li>테이블 러너</li>
      <li>팔찌</li>
      <li>풍선</li>
      <li>막대풍선</li>
      <li>깃발</li>
    </ul>
  </StepContainer>
);
export default PartyKit;
